import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { redirectAfterLogin } from '../utils/postLoginRedirect';
import '../pages/auth/AuthPublic.css';

const LoginLayer = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await login(email, password);
      if (result.success) {
        toast.success('Login effettuato!');
        redirectAfterLogin(result, navigate, location.state);
      } else {
        toast.error(result.message || 'Accesso non riuscito');
      }
    } catch {
      toast.error('Si è verificato un errore durante l’accesso');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vc-auth">
      <div className="vc-auth__card">
        <h1 className="vc-auth__title">Accedi</h1>
        <p className="vc-auth__lead">
          Entra per gestire appuntamenti, documenti e prenotazioni.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="vc-auth__field">
            <label htmlFor="vc-login-email">Email</label>
            <div className="vc-auth__input-wrap">
              <span className="vc-auth__icon" aria-hidden="true">
                <Icon icon="mage:email" />
              </span>
              <input
                id="vc-login-email"
                type="email"
                className="vc-auth__input"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="vc-auth__field">
            <label htmlFor="vc-login-password">Password</label>
            <div className="vc-auth__input-wrap">
              <span className="vc-auth__icon" aria-hidden="true">
                <Icon icon="solar:lock-password-outline" />
              </span>
              <input
                id="vc-login-password"
                type={showPassword ? 'text' : 'password'}
                className="vc-auth__input"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{ paddingRight: '3.25rem' }}
              />
              <button
                type="button"
                className="vc-auth__toggle-pw"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? 'Nascondi password' : 'Mostra password'}
              >
                {showPassword ? 'Nascondi' : 'Mostra'}
              </button>
            </div>
          </div>
          <div className="vc-auth__row">
            <Link to="/forgot-password" className="vc-auth__link">
              Password dimenticata?
            </Link>
          </div>
          <button
            type="submit"
            className="vc-btn vc-btn-primary vc-auth__submit"
            disabled={loading}
          >
            {loading ? 'Accesso in corso…' : 'Accedi'}
          </button>
        </form>
        <p className="vc-auth__footer">
          Non hai un account?{' '}
          <Link to="/register" state={location.state} className="vc-auth__link">
            Registrati
          </Link>
        </p>
      </div>
    </div>
  );
};

export default LoginLayer;
